var map = {
	"./addons.svg": 424,
	"./blog.svg": 425,
	"./calc.svg": 426,
	"./cdn.svg": 427,
	"./cdn24.svg": 428,
	"./cloud-network.svg": 429,
	"./combination-cloud.svg": 430,
	"./company-size.svg": 431,
	"./coprate.svg": 432,
	"./ddos.svg": 433,
	"./digital-tahavol.svg": 434,
	"./faq.svg": 435,
	"./free.svg": 436,
	"./how-to-start.svg": 437,
	"./in-xaas.svg": 438,
	"./industry.svg": 439,
	"./infra.svg": 440,
	"./left15.svg": 441,
	"./left7.svg": 442,
	"./main3.svg": 443,
	"./manage.svg": 444,
	"./manage24.svg": 445,
	"./migrate.svg": 446,
	"./organ-docs.svg": 447,
	"./organ-security.svg": 448,
	"./organ-solutions.svg": 449,
	"./organization.svg": 450,
	"./paas.svg": 451,
	"./prices.svg": 452,
	"./private-cloud.svg": 453,
	"./security.svg": 454,
	"./service-help.svg": 455,
	"./sla.svg": 456,
	"./special.svg": 457,
	"./storage.svg": 458,
	"./tech-services-for-organs.svg": 459,
	"./vpc.svg": 460,
	"./vps.svg": 461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;